import axios from "axios";

const API_BASE_URL = "https://echovault-backend.onrender.com";
//const API_BASE_URL = "http://localhost:3333"; // Replace with your API base URL

const token = localStorage.getItem("authToken"); // Replace with your token storage logic
console.log("Token:", token); // Debugging line to check the token value

const request = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
    "Authorization": token ? `Bearer ${token}` : "",
  },
});

// Add a request interceptor to include authorization token if available
request.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("authToken"); // Replace with your token storage logic
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Add a response interceptor to handle errors globally
request.interceptors.response.use(
  (response) => response,
  (error) => {
    console.error("API Error:", error.response || error.message);
    return Promise.reject(error.response || error.message);
  }
);

export default request;